(function () {
  var STORAGE_KEY = 'wave_wishlist';

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateCount();
  }

  function updateCount() {
    var count = getList().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function markActiveButtons() {
    var ids = getList().map(function (i) { return String(i.id); });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (ids.indexOf(String(btn.dataset.productId)) > -1) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  function toggle(btn) {
    var id = String(btn.dataset.productId);
    var list = getList();
    var idx = list.findIndex(function (i) { return String(i.id) === id; });

    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({
        id: id,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        url: btn.dataset.productUrl
      });
    }

    saveList(list);
    markActiveButtons();
    renderPage();
  }

  function renderPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (!container) return;

    var list = getList();

    if (!list.length) {
      container.innerHTML = '<div class="wishlist-page__empty"><p>Aún no tienes favoritos guardados.</p><p><a href="/collections/all">Ver todos los productos</a></p></div>';
      return;
    }

    var html = '<div class="wishlist-page__grid">';
    list.forEach(function (item) {
      html += '' +
        '<div class="wishlist-page__item">' +
          '<a href="' + item.url + '">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '') +
          '</a>' +
          '<p class="wishlist-page__item-title"><a href="' + item.url + '">' + item.title + '</a></p>' +
          '<p class="wishlist-page__item-price">' + item.price + '</p>' +
          '<button type="button" class="wishlist-page__item-remove" data-wishlist-remove="' + item.id + '">Quitar de favoritos</button>' +
        '</div>';
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = String(btn.dataset.wishlistRemove);
        var list = getList().filter(function (i) { return String(i.id) !== id; });
        saveList(list);
        markActiveButtons();
        renderPage();
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
  });

  document.addEventListener('DOMContentLoaded', function () {
    markActiveButtons();
    updateCount();
    renderPage();
  });
})();
